import type { ClientGeoArea } from '@DigitaleDoerfer/digitale-doerfer-api';
import { ClientGeoAreaGeoAreaTypeEnum } from '@DigitaleDoerfer/digitale-doerfer-api';

export const SYNTHETIC_ROOT_AREA_ID = '__all__';

export const buildPickerRoot = (
  treeRoots: ClientGeoArea[] | undefined,
  allAreasLabel: string
): ClientGeoArea | undefined => {
  if (!treeRoots || treeRoots.length === 0) return undefined;
  if (treeRoots.length === 1) return treeRoots[0];
  return {
    id: SYNTHETIC_ROOT_AREA_ID,
    name: allAreasLabel,
    childGeoAreas: treeRoots,
    center: treeRoots[0].center,
    geoAreaType: ClientGeoAreaGeoAreaTypeEnum.Unknown
  };
};

export const expandSyntheticRootIds = (
  ids: string[],
  treeRoots: ClientGeoArea[] | undefined
): string[] => {
  if (!ids.includes(SYNTHETIC_ROOT_AREA_ID)) return ids;
  const realRootIds = (treeRoots ?? []).map((root) => root.id);
  return [...ids.filter((id) => id !== SYNTHETIC_ROOT_AREA_ID), ...realRootIds];
};
